import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

interface Company {
  id: number;
  name: string;
}

export const useCompanies = () => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserCompanies = async () => {
      try {
        // Get current session
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.user) {
          setLoading(false);
          return;
        }

        const { data: userCompanies } = await supabase
          .from('user_companies')
          .select('company_id')
          .eq('user_id', session.user.id);

        const { data, error } = await supabase
          .from('company')
          .select('id, name')
          .in('id', userCompanies?.map(uc => uc.company_id) || [])
          .order('name');

        if (error) throw error;
        setCompanies(data || []);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch companies');
      } finally {
        setLoading(false);
      }
    };

    // Subscribe to auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_IN') {
        fetchUserCompanies();
      }
    });

    // Initial fetch
    fetchUserCompanies();

    return () => subscription.unsubscribe();
  }, []);

  return { companies, loading, error };
}; 